import { endpoints } from "@/utils/common/requests/endpoints";
import { useAction } from "@/utils/useQuery/useAction";

/**
 * @typedef {Object} UpdateCrewMemberRoleArg
 * @property {string} crewId
 * @property {{ userId: string, role: string }} payload
 */

/**
 * @returns {import("@/utils/useQuery/useAction").ActionReturn<UpdateCrewMemberRoleArg>}
 */
export function useUpdateCrewMemberRole() {
	return useAction({
		url: (arg) => endpoints.crew.UPDATE_MEMBER_ROLE(arg.crewId),
		method: "patch",
	});
}
